// src/contexts/SettingsContext.jsx
import React, { createContext, useState, useEffect } from 'react';
import axios from '../axios';

export const SettingsContext = createContext({ decimalPlaces: 2 });

export function SettingsProvider({ children }) {
  const [decimalPlaces, setDecimalPlaces] = useState(2);
  useEffect(() => {
    const companyId = localStorage.getItem('companyId');
    if (!companyId) return;
    axios
      .get(`/ProgramSettings?companyId=${companyId}`)
      .then(r => setDecimalPlaces(r.data.decimalPlaces))
      .catch(() => setDecimalPlaces(2));
  }, []);
  return (
    <SettingsContext.Provider value={{ decimalPlaces }}>
      {children}
    </SettingsContext.Provider>
  );
}
